import React, { useState, useEffect, useRef } from 'react';
import { Form, Input, Table, ConfigProvider, Button, Space, Radio, Modal, Spin, message, Tag, Typography, Card } from 'antd';
import { SearchOutlined, SettingOutlined, DeleteOutlined, ExperimentOutlined, CloseOutlined } from '@ant-design/icons';
import { hnrequest } from '@/utils'

import Highlighter from 'react-highlight-words';
import './index.scss'
import zhCN from 'antd/locale/zh_CN';

const { Paragraph, Text } = Typography;
const optionsz1 = [
  { label: '启用', value: 'Y', }, { label: '关闭', value: 'N', }
];
const optionsz2 = [
  { label: '显示', value: 'Y', }, { label: '关闭', value: 'N', }
];

const Dba = () => {
  const [messageApi, contextHolder] = message.useMessage();
  const [tdown] = Form.useForm();
  const [tdel] = Form.useForm();
  const [formxf] = Form.useForm();
  const [spinning, setSpinning] = useState(false);
  const [ccpxx, setccpxx] = useState([]);// 选择的产品信息
  const [open, setOpen] = useState(false);
  const [opend, setOpend] = useState(false);
  const [openy, setOpeny] = useState(false);

  const [bangm, setbangm] = useState([]);
  const [ticks, setticks] = useState([]);// 选择的产品信息


  const toSet = async (e) => {
    setSpinning(true)
    setOpen(false)
    const rq = await hnrequest.post('/pdbset', e)
    if (rq.return_code) { setSpinning(false) }
    setticks(rq.ticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });

  }

  const toDel = async (d) => {
    setSpinning(true)
    setOpend(false)
    const dbd = await hnrequest.post('/pdbdel', d)
    if (dbd.return_code) { setSpinning(false) }
    setticks(dbd.ticks)
    messageApi.open({ type: dbd.return_code, content: dbd.return_msg, });
    // dbd.return_code === "success" && setbangm(bangm.filter(item => item.key !== d.dbno))
  }


  useEffect(() => {
    async function getau() {
      const res = await hnrequest.post('/pdb_list', { ticks: ticks })
      setbangm(res.rescode)
    }
    getau()
  }, [ticks])

  const [searchText, setSearchText] = useState('');
  const [searchedColumn, setSearchedColumn] = useState('');
  const searchInput = useRef(null);
  const handleSearch = (selectedKeys, confirm, dataIndex) => {
    confirm();
    setSearchText(selectedKeys[0]);
    setSearchedColumn(dataIndex);
  };
  const handleReset = (clearFilters) => {
    clearFilters();
    setSearchText('');
  };
  const getColumnSearchProps = (dataIndex) => ({
    filterDropdown: ({ setSelectedKeys, selectedKeys, confirm, clearFilters, close }) => (
      <div
        style={{
          padding: 8,
        }}
        onKeyDown={(e) => e.stopPropagation()}
      >
        <Input
          ref={searchInput}
          placeholder={`检索内容`}
          value={selectedKeys[0]}
          onChange={(e) => setSelectedKeys(e.target.value ? [e.target.value] : [])}
          onPressEnter={() => handleSearch(selectedKeys, confirm, dataIndex)}
          style={{
            marginBottom: 8,
            display: 'block',
          }}
        />
        <Space>
          <Button
            type="primary"
            onClick={() => handleSearch(selectedKeys, confirm, dataIndex)}
            icon={<SearchOutlined />}
            size="small"
            style={{
              width: 90,
            }}
          >
            检索
          </Button>
          <Button
            onClick={() => clearFilters && handleReset(clearFilters)}
            size="small"
            style={{
              width: 90,
            }}
          >
            重置
          </Button>

          <Button
            type="link"
            size="small"
            onClick={() => {
              close();
            }}
          >
            关闭
          </Button>
        </Space>
      </div>
    ),
    filterIcon: (filtered) => (
      <SearchOutlined
        style={{
          color: filtered ? '#1677ff' : undefined,
        }}
      />
    ),
    onFilter: (value, record) =>
      record[dataIndex].toString().toLowerCase().includes(value.toLowerCase()),
    filterDropdownProps: (visible) => {
      if (visible) {
        setTimeout(() => searchInput.current?.select(), 100);
      }
    },
    render: (text) =>
      searchedColumn === dataIndex ? (
        <Highlighter
          highlightStyle={{
            backgroundColor: '#ffc069',
            padding: 0,
          }}
          searchWords={[searchText]}
          autoEscape
          textToHighlight={text ? text.toString() : ''}
        />
      ) : (
        text
      ),
  });


  const ppth = (e, f) => {
    setccpxx(e)
    f === "del" && setOpend(true)
    f === "set" && setOpen(true)
    const dbnoj = { dbno: e.key };
    const formjson = Object.assign(e.setj[0], dbnoj);

    f === "set" && tdown.setFieldsValue(formjson)
    f === "del" && tdel.setFieldsValue(formjson)
    f === "setyy" && setOpeny(true)
    f === "setyy" && formxf.setFieldsValue({ dbno: e.key })
    f === "setyy" && e.sjson.dyyjson !== undefined && formxf.setFieldsValue({ yyjson: e.sjson.dyyjson })
    f === "setyy" && e.sjson.dyyjson === undefined && formxf.setFieldsValue({ yyjson: "" })
    // console.log(f, e.key,e.sjson.dyyjson)
  }
  const onFxfsq = async (e) => {
    const rq = await hnrequest.post('/p_adyyxx', e)

    setOpen(false)
    setticks(rq.setticks)
    messageApi.open({ type: rq.return_code, content: rq.return_msg, });
  }



  const columns = [
    {
      title: '',
      dataIndex: 'key',
      key: 'key',
      render: (_, record) => (<Space><Button type="primary" icon={<SettingOutlined />} onClick={() => ppth(record, "set")} />
        <Button color='orange' variant="filled" icon={<DeleteOutlined />} onClick={() => ppth(record, "del")} />
        {record.plb === "1001" && <Tag icon={<ExperimentOutlined />} color="#69b1ff" onClick={() => ppth(record, 'setyy')}>
          原药信息
        </Tag>}
      </Space>

      ),
    },

    {
      title: '数据批号',
      dataIndex: 'key',
      ...getColumnSearchProps('key'),
      key: 'key',
      sorter: (a, b) => a.key - b.key,
      sortDirections: ['descend', 'ascend'],
    },
    {
      title: '类型',
      dataIndex: 'plb',
      key: 'plb',
      render: (_, record) => (
        <Space size="small">
          {record.dblx === "outdb" && <Tag color="#108ee9" >Group</Tag>}
          {record.dblx === "indb" && <Tag color="#87d068" >Single</Tag>}
          {record.plb === "1001" && <Tag color="volcano" >农药</Tag>}
          {record.plb === "1003" && <Tag color="green" >种子</Tag>}
          {record.plb === "1002" && <Tag color="purple" >农肥&其他</Tag>}
          {record.plb === "1004" && <Tag color="purple" >农肥&其他</Tag>}
        </Space>
      ),
    },
    {
      title: '产品名称',
      key: 'pname',
      dataIndex: 'pname',
    },
    {
      title: '生成时间',
      dataIndex: 'scsj',
      key: 'scsj',
      ...getColumnSearchProps('scsj'),
    },
    {
      title: '数量',
      dataIndex: 'db_total',
      key: 'db_total',
    },
    {
      title: '下载次数',
      dataIndex: 'db_ds',
      key: 'db_ds',
    },

  ];














  return (
    <>


      <ConfigProvider locale={zhCN} >
        {contextHolder}
        <Table size="small"
          // rowSelection={   {type:"checkbox",...rowSelection,}} 
          columns={columns} dataSource={bangm} />

        <Modal
          title="数据信息"
          centered
          open={open}
          footer={false}
          onOk={() => setOpen(false)}
          onCancel={() => setOpen(false)}
        >
          <Paragraph>产品名称:{ccpxx.pname}  <Text>数据批号:{ccpxx.key}</Text> </Paragraph>


          <Form form={tdown} onFinish={toSet}>
            <Form.Item name="dbno" hidden="true"><Input /></Form.Item>
            <Space.Compact>
              <Space>

                <Form.Item label="激活状态" name="jh_zt"
                >
                  <Radio.Group
                    options={optionsz1}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>

                <Form.Item label="扫描次数" name="s_cs"
                >
                  <Radio.Group
                    options={optionsz2}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>
              </Space>
            </Space.Compact>
            <Space.Compact>

              <Space>

                <Form.Item label="定位信息" name="s_dw"
                >
                  <Radio.Group
                    options={optionsz2}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>

                <Form.Item label="流转信息" name="s_lz"
                >
                  <Radio.Group
                    options={optionsz2}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>
              </Space>




            </Space.Compact>


            <Space.Compact>

              <Space>

                <Form.Item label="启用状态" name="s_qy"
                >
                  <Radio.Group
                    options={optionsz1}
                    optionType="button"
                    size="small"
                  />


                </Form.Item>

                <Form.Item label="验证互动" name="s_yz"
                >
                  <Radio.Group
                    options={optionsz1}
                    optionType="button"
                    size="small"
                  />
                </Form.Item>
              </Space>




            </Space.Compact>

            <Form.Item >
              <Button type="primary" htmlType="submit" block>
                设 置
              </Button>
            </Form.Item>

          </Form>




        </Modal>






        {/*  */}

        <Modal
          title="原药信息维护"
          footer={null}
          style={{ top: 98 }}
          open={openy}
          // onOk={() => onFxfsq()}
          onCancel={() => setOpeny(false)}
          width={1000}
        >



          <Form
            name="dbxfsq"
            layout="horizontal"
            onFinish={onFxfsq}
            form={formxf}
          >
            <Form.Item name='dbno'
              hidden={true}
            >
              <Input />
            </Form.Item>
            <Form.List name="yyjson" >



              {(fields, { add, remove }) => (


                <div
                  style={{
                    display: 'flex',
                    rowGap: 16,
                    flexDirection: 'column',
                  }}
                >
                  <Space>
                    数据批号：{ccpxx.key} 产品名称：{ccpxx.pname} <Tag icon={<ExperimentOutlined />} color="#69b1ff" onClick={() => add()} > + 原药信息</Tag>

                  </Space>




                  {fields.map((field) => (
                    <Card
                      size="small"
                      title={`原药信息 ${field.name + 1}`}
                      key={field.key}
                      extra={
                        <CloseOutlined
                          onClick={() => {
                            remove(field.name);
                          }}
                        />
                      }
                    >
                      <Form.Item label="">
                        <Form.List name={[field.name, 'ymsglist']}>
                          {(subFields, subOpt) => (
                            <div
                              style={{
                                display: 'flex',
                                flexDirection: 'column',
                                rowGap: 16,
                              }}
                            >
                              {subFields.map((subField) => (
                                <Space key={subField.key}>
                                  <Form.Item
                                   rules={[{ required: true, message: '该信息不能为空!' }]}
                                    name={[subField.name, 'mc']}>
                                    <Input placeholder="类目名称" count={{ show: true, }} allowClear />
                                  </Form.Item>
                                  <Form.Item
                                    rules={[{ required: true, message: '该信息不能为空!' }]}
                                    name={[subField.name, 'nr']}>
                                    <Input placeholder="内容" style={{ width: "400px" }} count={{ show: true, }} allowClear />
                                  </Form.Item>
                                  <CloseOutlined
                                    onClick={() => {
                                      subOpt.remove(subField.name);
                                    }}
                                  />
                                </Space>
                              ))}
                              <Button type="dashed" onClick={() => subOpt.add()} >
                                + 添加项目
                              </Button>
                            </div>
                          )}
                        </Form.List>
                      </Form.Item>
                    </Card>
                  ))}
                </div>
              )}
            </Form.List>

            <Form.Item>
              <Button type="primary"
                htmlType="submit"
                style={{ marginTop: "20px" }}
                block={true} >
                提   交
              </Button>
            </Form.Item>
          </Form>
        </Modal>

        {/*  */}


        <Modal
          title="删除数据"
          centered
          open={opend}
          footer={false}
          onOk={() => setOpend(false)}
          onCancel={() => setOpend(false)}
        >
          <Paragraph>产品名称:{ccpxx.pname}  <Text>数据批号:{ccpxx.key}</Text> </Paragraph>
          <Form form={tdel} onFinish={toDel}>

            <Form.Item name="dbno" hidden="true"><Input /></Form.Item>

            <Form.Item >
              <Button type="primary" htmlType="submit" block>
                提 交
              </Button>
            </Form.Item>

          </Form>

        </Modal>


        <Spin spinning={spinning} tip="数据整理中，请稍等..." fullscreen />

      </ConfigProvider>
    </>

  );
};
export default Dba;